import { useCallback, useRef } from "react";
import {BlockerFunction, useBeforeUnload, useBlocker} from "react-router-dom";

export const useNavigationBlocker = (hasUnsavedChanges: () => boolean) => {
    const useBlockerRef = useRef(true);

    const shouldBlock = useCallback<BlockerFunction>(({ currentLocation, nextLocation }) =>
            useBlockerRef.current && hasUnsavedChanges() && currentLocation.pathname !== nextLocation.pathname,
        [hasUnsavedChanges]);

    const blocker = useBlocker(shouldBlock);
    
    const setBlockerActive = useCallback((active: boolean) => {
        useBlockerRef.current = active;
    }, []);

    useBeforeUnload(useCallback((e: BeforeUnloadEvent) => {
        if (!useBlockerRef.current || !hasUnsavedChanges()) return;
        e.preventDefault();
        e.returnValue = true; // Included for legacy support, e.g. Chrome/Edge < 119
    }, [hasUnsavedChanges]));

    return {blocker, setBlockerActive};
}